import { render, staticRenderFns } from "./MpFollows.vue?vue&type=template&id=81e5754e&"
import script from "./MpFollows.vue?vue&type=script&lang=js&"
export * from "./MpFollows.vue?vue&type=script&lang=js&"
import style0 from "./MpFollows.vue?vue&type=style&index=0&id=81e5754e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports